import React, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { NavLink } from '../NavLink';
import { jsx as _jsx } from "react/jsx-runtime";
export function IngramAppStore(props) {
  var appStore = props.appStore;
  var navItems = useMemo(function () {
    return appStore ? appStore.map(function (store) {
      return {
        content: /*#__PURE__*/_jsx("img", {
          alt: store.name,
          src: typeof store.iconImage === 'string' ? store.iconImage : ''
        }),
        key: store.name,
        label: store.name,
        url: store.url
      };
    }) : [];
  }, [appStore]);
  return /*#__PURE__*/_jsx(StyledStack, {
    marginTop: 4,
    "data-element": "StyledStack",
    "data-component": "IngramAppStore",
    "data-source-file": "IngramAppStore.tsx",
    children: navItems.map(function (navItem) {
      return /*#__PURE__*/_jsx(StyledNavLink, {
        "data-testid": navItem.key,
        navItem: navItem
      }, navItem.key);
    })
  });
}
var StyledNavLink = styled(NavLink)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& img': {
      height: '40px',
      width: '135px'
    },
    '@media only screen and (max-width: 1023.9px)': {
      margin: '0 13px 0 0 !important'
    },
    display: 'inline-block',
    height: 40
  };
});
var StyledStack = styled(Stack)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    '@media screen and (max-width: 1024.9px)': {
      flexDirection: 'column'
    },
    '@media screen and (min-width: 1024.9px)': {
      flexDirection: 'row'
    },
    display: 'flex',
    gap: '16px'
  };
});